var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.visitFrequency"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.visitFrequency,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "visitFrequency", $$v)
                        },
                        expression: "form.visitFrequency",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.lastPurchaseTime"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.lastPurchaseTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "lastPurchaseTime", $$v)
                        },
                        expression: "form.lastPurchaseTime",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.pointBalance"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.pointBalance,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "pointBalance", $$v)
                        },
                        expression: "form.pointBalance",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.rebateBalance"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.rebateBalance,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rebateBalance", $$v)
                        },
                        expression: "form.rebateBalance",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.lastVisitTime"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.lastStartTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "lastStartTime", $$v)
                        },
                        expression: "form.lastStartTime",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.contractTM"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.rtlTmallFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rtlTmallFlag", $$v)
                        },
                        expression: "form.rtlTmallFlag",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.otherRecord.contractJD"
                      ),
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.rtlJdFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rtlJdFlag", $$v)
                        },
                        expression: "form.rtlJdFlag",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }